import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { SharedLibModule } from '@app/core/shared-lib/shared-lib.module';

export interface ResultData {
  _id: string;
  nominative: string;
  propertyName?: string;
  address?: string;
  notes?: string; //per i leads
  note?: string;
  when?: string;
  eventType?: string;
  phone?: string;
  email?: string;
}

@Component({
  selector: 'app-search-modal-hit',
  standalone: true,
  imports: [CommonModule, RouterModule, SharedLibModule],
  template: `
    <a [routerLink]="routerLink" [queryParams]="queryParams" class="mb-2">
      <div class="p-4 border border-neutral-300 rounded-md hover:bg-neutral-200 bg-neutral-100 min-h-[6rem] transition-colors">
        <div class="flex gap-4 justify-between h-full">
          <div class="flex-1">
            <div class="flex flex-wrap items-baseline">
              <div *ngIf="data.nominative" class="font-bold text-xl mr-2" [innerHTML]="data.nominative"></div>
              <div *ngIf="data.propertyName" class="text-lg text-neutral-600 mr-2">( <span [innerHTML]="data.propertyName"></span> )</div>
              <p-tag [value]="indexType" [severity]="indexSeverity" styleClass="text-sm font-semibold "> </p-tag>
            </div>

            <div *ngIf="data.address" class="text-gray-800 mt-1">
              <span [innerHTML]="data.address"></span>
            </div>

            <div class="flex gap-3 items-center align-middle">
              <div *ngIf="data.email" class="text-gray-800 mt-1">
                <lucide-icon [name]="'mail'" [size]="16" class="pt-2"></lucide-icon>

                <span class="ms-1" [innerHTML]="data.email"></span>
              </div>
              <div *ngIf="data.phone" class="text-gray-800 mt-1">
                <lucide-icon [name]="'phone'" [size]="16" class="pt-2"></lucide-icon>

                <span class="ms-1" [innerHTML]="data.phone"></span>
              </div>
            </div>

            <div *ngIf="data.eventType" class="text-gray-800 mt-1 font-bold capitalize">
              <span [innerHTML]="data.eventType"></span>
            </div>
            <div *ngIf="data.when" class="text-gray-800 mt-1">
              <span [innerHTML]="data.when"></span>
            </div>

            <div *ngIf="data.notes && data.notes.length > 0" class="text-gray-800">
              <span class="text-ellipsis" [innerHTML]="data.notes"></span>
            </div>
            <div *ngIf="data.note" class="text-gray-800">
              <span class="text-ellipsis" [innerHTML]="data.note"></span>
            </div>
          </div>

          <div class="flex items-center text-neutral-400">
            <lucide-icon [name]="'chevron-right'"></lucide-icon>
          </div>
        </div>
      </div>
    </a>
  `,
})
export class SearchModalHitComponent {
  @Input({ required: true }) data!: ResultData;

  @Input() routerLink: any[] = ['/sales/working-unit/info'];
  @Input() queryParams: Record<string, any> = {};
  @Input() indexType = ''
  @Input() indexSeverity: "success" | "secondary" | "info" | "warning" | "danger" | "contrast" | undefined = 'info'
}
